export default "__VITE_ASSET__D7p7p9GD__"